/* globals google, jQuery */
(function($) {

  $.fn.acfMap = function(options) {
    new AcfMap(this, options);
  };

  function AcfMap($el, options) {
    this.$el = $($el);

    options = options || {};
    this._markerSelector = options.markerSelector || '.acf-map-marker';
    this._zoomLevel = options.zoomLevel || parseInt(this.$el.data('zoom-level')) || 14;
    this._maxZoom = options.maxZoom || 18;

    var self = this;
    this._initInfoWindow = options.initInfoWindow;
    if (!this._initInfoWindow) {
      this._initInfoWindow = this.defaultInitInfoWindow;
    }

    this.$el.each(function() {
      self.createMap($(this));
    });
  }

  /**
   *  Render a Google Map onto the given jQuery element
   *
   *  @type  function
   *  @date  8/11/2013
   *  @since 4.3.0
   *
   *  @param $el (jQuery element)
   *  @return  n/a
   */
  AcfMap.prototype.createMap = function( $el ) {
    // markers
    var $markers = $el.find(this._markerSelector);

    // vars
    var args = {
      zoom:             this._zoomLevel,
      maxZoom:          this._maxZoom,
      center:           new google.maps.LatLng(0, 0),
      mapTypeId:        google.maps.MapTypeId.ROADMAP,
      mapTypeControl:   false,
      rotateControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#717171"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#fff200"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}]
    };

    // create map
    var map = new google.maps.Map( $el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    var self = this;
    $markers.each(function(){
      self.addMarker( $(this), map );
    });

    // center map
    self.centerMap( map, this._zoomLevel );

    // return
    return map;
  };

  /**
   *  Add a marker to the given Google Map object
   *
   *  @type  function
   *  @date  8/11/2013
   *  @since 4.3.0
   *
   *  @param $markerElem (jQuery element)
   *  @param map (Google Map object)
   *  @return  n/a
   */
  AcfMap.prototype.addMarker = function( $markerElem, map ) {

    var lat = $markerElem.attr('data-lat'),
        lng = $markerElem.attr('data-lng');

    if (!lat || !lng) {
      console.log('lat/lng coords not found on $markerElem:', $markerElem);
      return;
    }

    // Marker coordinates
    var latlng = new google.maps.LatLng(lat, lng);

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map:      map,
      icon:     this.getMarkerIcon($markerElem),
    });

    // save raw jQuery element associated with this marker
    marker.$elem = $markerElem;

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    /*if( $markerElem.html() )
    {
      var infoWindow = this._initInfoWindow($markerElem, marker, map);
      marker._infoWindow = infoWindow;

      // show info window when marker is clicked
      marker._infoWindow = infoWindow;
      marker.addListener('click', function() {
        // hide all other infoWindows first
        map.markers.forEach(function(_marker) {
          _marker._infoWindow.close();
        });
        infoWindow.open( map, marker );
      });
  }*/

  };

  /**
   *  Center the map, showing all markers attached to this map
   *
   *  @type  function
   *  @date  8/11/2013
   *  @since 4.3.0
   *
   *  @param map (Google Map object)
   *  @return  n/a
   */
  AcfMap.prototype.centerMap = function( map, zoomLevel ) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){
      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
      bounds.extend( latlng );
    });

    // only 1 marker?
    if( map.markers.length === 1 )
    {
      // set center of map
      map.setCenter( bounds.getCenter() );
      map.setZoom( zoomLevel );
    }
    else
    {
      // fit to bounds
      map.fitBounds( bounds );

      // zoom back out
      google.maps.event.addListenerOnce(map, 'idle', function() {
        if (map.getZoom() > zoomLevel) {
          map.setZoom( zoomLevel );
        }
      });
    }
  };

  AcfMap.prototype.getMarkerIcon = function($markerElem) {
    var sizeData = $markerElem.data('icon-size') || "40,40",
      size = sizeData.split(','),
      width, height;

    if (size.length === 1) {
      width  = parseInt(size[0]) || 40;
      height = parseInt(size[0]) || 40;
    } else if (size.length === 2) {
      width  = parseInt(size[0]) || 40;
      height = parseInt(size[1]) || 40;
    } else {
      width  = 40;
      height = 40;
    }

    return {
      url: $markerElem.data('icon-url'),
      scaledSize: new google.maps.Size(width, height),
      size: new google.maps.Size(width, height),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(50, 120)
    };
  };

  AcfMap.prototype.defaultInitInfoWindow = function($markerElem) {
    // create info window
    return new google.maps.InfoWindow({
      content: $markerElem.html(),
    });
  };

})(jQuery);
